import AuctionWizardVehicleSelector from "@/src/components/organisms/VehicleSelectorGroup/AuctionWizardVehicleSelector";
import HomePageVehicleSelector from "@/src/components/organisms/VehicleSelectorGroup/HomePageVehicleSelector";
import { VehicleSelectorNavigationView } from "@/src/components/organisms/VehicleSelectorGroup/vehicleSelector.constants";

import { VehicleType } from "@/src/types/types";

interface VehicleSelectorGroupProps {
  vehicleType: VehicleType;
  navigationView: VehicleSelectorNavigationView;
}

const VehicleSelectorGroup = (props: VehicleSelectorGroupProps) => {
  const { vehicleType, navigationView } = props;

  if (navigationView === "homePageView") {
    return <HomePageVehicleSelector vehicleType={vehicleType} />;
  }

  return <AuctionWizardVehicleSelector vehicleType={vehicleType} />;
};

export default VehicleSelectorGroup;
